import React from "react";
import styles from "./Button.module.scss";
import classNames from "classnames";

type ButtonVariant = "primary" | "green" | "black" | "white";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ style, className, children, type, variant = "primary", ...rest }, ref) => {
    const buttonClassName = classNames(styles.button, className, {
      [styles.variantGreen]: variant === "green",
      [styles.variantBlack]: variant === "black",
      [styles.variantWhite]: variant === "white",
    });

    return (
      <button aria-pressed type={type} style={style} ref={ref} className={buttonClassName} {...rest}>
        {children}
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
